import _ from "lodash"

import { DealId, DealLineId, DealLineSkuId, SkuId } from "shared/hubrise/ids"
import { ICatalog, IDealLineSku } from "shared/hubrise/models"
import { removeInArrayById, replaceInArrayById } from "shared/utils/javascript"

import { updatedCatalog } from "./Catalog"

/**
 * Add a list of SKUs to a deal line.
 * @param catalog
 * @param dealId
 * @param dealLineId
 * @param skuIds
 */
export function add(catalog: ICatalog, dealId: DealId, dealLineId: DealLineId, skuIds: Array<SkuId>): ICatalog {
  return updatedCatalog(catalog, {
    deals: replaceInArrayById(catalog.data.deals, dealId, (deal) => ({
      ...deal,
      lines: replaceInArrayById(deal.lines, dealLineId, (dealLine) => ({
        ...dealLine,
        skus: _.uniqBy(
          [
            ...dealLine.skus,
            ...skuIds.map((skuId) => ({ id: DealLineSkuId(catalog.idGenerator()), skuId, extraCharge: null })),
          ],
          ({ skuId }) => skuId,
        ),
      })),
    })),
  })
}

/**
 * Delete the deal line sku. The function name is because delete is a reserved JS word.
 * @param catalog
 * @param dealId
 * @param dealLineId
 * @param dealLineSkuId
 */
export function doDelete(
  catalog: ICatalog,
  dealId: DealId,
  dealLineId: DealLineId,
  dealLineSkuId: DealLineSkuId,
): ICatalog {
  return updatedCatalog(catalog, {
    deals: replaceInArrayById(catalog.data.deals, dealId, (deal) => ({
      ...deal,
      lines: replaceInArrayById(deal.lines, dealLineId, (dealLine) => ({
        ...dealLine,
        skus: removeInArrayById(dealLine.skus, dealLineSkuId),
      })),
    })),
  })
}

/**
 * Update a field in a deal line sku.
 * @param catalog
 * @param dealId
 * @param dealLineId
 * @param dealLineSkuId
 * @param fieldName
 * @param value
 */
export function update<T extends keyof IDealLineSku>(
  catalog: ICatalog,
  dealId: DealId,
  dealLineId: DealLineId,
  dealLineSkuId: DealLineSkuId,
  fieldName: T,
  value: IDealLineSku[T],
): ICatalog {
  return updatedCatalog(catalog, {
    deals: replaceInArrayById(catalog.data.deals, dealId, (deal) => ({
      ...deal,
      lines: replaceInArrayById(deal.lines, dealLineId, (dealLine) => ({
        ...dealLine,
        skus: replaceInArrayById(dealLine.skus, dealLineSkuId, (dealLineSku) => ({
          ...dealLineSku,
          [fieldName]: value,
        })),
      })),
    })),
  })
}
